export default __webpack_public_path__ + "static/media/dashboard.d836820a.png";